import { createSelector } from 'reselect';

export const selectedUsageClaims = (state: any) => {
  return state.get('usageClaims');
};

const makeSelectUsageClaims = () =>
  createSelector(selectedUsageClaims, claims => {
    if (claims && claims.get('claims')) {
      return claims.get('claims').toJS();
    }
    return [];
  });

const makeSelectCountUsageClaims = () =>
  createSelector(selectedUsageClaims, claims => {
    if (claims && claims.get('countClaims')) {
      return claims.get('countClaims');
    }
    return 0;
  });

export { makeSelectUsageClaims, makeSelectCountUsageClaims };
